// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".submission-completed[data-v-427649ac]{height:400px;justify-content:center;margin:auto;text-align:center}@media (min-width:600px){.submission-completed[data-v-427649ac]{max-width:50vw}}", ""]);
// Exports
module.exports = exports;
